module.exports = __webpack_public_path__ + "static/media/Worlddutyfree.46f467a8.png";